import React from "react";
import "./globalSection.css";

const GlobalSection = ({
  sectionTitle,
  sectionSubtitle,

  sectionButtons = [],

  sectionCategories = [],
}) => {

  return (

    <section className="global-section">

      <div className="container">

        {/* TOP SECTION */}
        <div className="row align-items-center mb-5">

          {/* LEFT CONTENT */}
          <div className="col-lg-6">

            <h2 className="section-title">
              {sectionTitle}
            </h2>

            <p className="exporter-sub">
              {sectionSubtitle}
            </p>

          </div>

          {/* RIGHT BUTTONS */}
          {sectionButtons.length > 0 && (

            <div className="col-lg-6 text-lg-end mt-3 mt-lg-0">

              <div className="exporter-buttons">

                {sectionButtons.map((button, index) => (

                  <button
                    key={index}
                    className={`btn-chip ${
                      index === 0 ? "active" : ""
                    }`}
                  >
                    {button}
                  </button>

                ))}

              </div>

            </div>

          )}

        </div>

        {/* IMAGE CARDS */}
        <div className="row g-4">

          {sectionCategories.map((category, index) => (

            <div
              className="col-lg-3 col-md-6"
              key={index}
            >

              <div className="category-card">

                <img
                  src={category.img}
                  alt={category.title}
                />

                <div className="overlay"></div>

                <div className="category-content">

                  <h5>{category.title}</h5>

                  <span className="explore-btn">
                    Explore →
                  </span>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
};

export default GlobalSection;